

$.fn.isMail = function () {
	var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
	return regex.test( $( this ).val() );
};
Date.prototype.addDays = function ( days ) {
	var dat = new Date( this.valueOf() );
	dat.setDate( dat.getDate() + days );
	return dat;
};

Date.prototype.addHours = function ( hours ) {
	var dat = new Date( this.valueOf() );
	dat.setHours( dat.getHours() + hours );
	return dat;
};
Date.prototype.addMinutes = function ( minutes ) {
	var dat = new Date( this.valueOf() );
	dat.setMinutes( dat.getMinutes() + minutes );
	return dat;
};



Array.prototype.MaxTimeLine = function () {
	var maxVals = this.valueOf().map( function ( elt ) {
		var tmp = elt.slice( 1 );
		return Math.max.apply( Math, tmp );
	} );
	if ( isNaN( Math.ceil( Math.max.apply( Math, maxVals ) ) ) ) {
		return -1;
	}
	return Math.ceil( Math.max.apply( Math, maxVals ) );
};


Array.prototype.MinTimeLine = function () {
	var tmp = 10000;
	for ( var i = 0; i < this.length; i++ ) {
		if ( parseFloat( this[ i ][ 1 ] ) < tmp ) tmp = this[ i ][ 1 ];
	}
	return tmp;
	//var minVals = this.valueOf().map(function(elt) {
	//	var tmp = elt.slice(1);

	//	return Math.min.apply(Math, tmp);
	//});
	//return Math.floor(Math.min.apply(Math, minVals));
};

$.params = function () {
	var vars = [], hash;
	var hashes = window.location.href.slice( window.location.href.indexOf( '?' ) + 1 ).split( '&' );
	for ( var i = 0; i < hashes.length; i++ ) {
		hash = hashes[ i ].split( '=' );
		vars.push( hash[ 0 ] );
		vars[ hash[ 0 ] ] = hash[ 1 ];
	}
	return vars;
};

Array.prototype.testPrognose = function ( column ) {
	for ( var i = 0; i < this.length; i++ ) {
		if ( parseFloat( this[ i ][ column ] ) > 0 ) return true;
	}
	return false;
};
